import React, { useState } from "react";
import styled from "styled-components";
import InputField from "./InputField.tsx";

import { TfiSave } from "react-icons/tfi";

import Button from "./Button.tsx";

import { addNewType } from "../../../services/filamentService.js";
import { addNewCategory } from "../../../services/productsService.js";

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  padding: 1rem 2rem;

  align-items: center;
`;
const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    min-width: 200px;
  }
`;

const SettingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 1rem;
  width: 100%;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
`;

interface Props {
  closeAddMode: (string) => void;
}

const AddCategoryComponent: React.FC<Props> = ({ closeAddMode }) => {
  const [isError, setIsError] = useState(false);

  const [name, setName] = useState("");

  const handleSave = async () => {
    // Save the filament to the database

    if (name) {
      setIsError(false);

      const category = {
        categoryName: name,
      };

      try {
        await addNewCategory(category);
        closeAddMode("success");
      } catch (error) {
        closeAddMode("error");
        console.error("Error creating type:", error);
      }
    } else {
      setIsError(true);
    }
  };

  return (
    <Wrapper data-testid="add-category-tile">
      <Container>
        <SettingWrapper data-testid="supplier-settings">
          <InputField
            name="type"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            isRequired
            placeholder="Nume categorie"
          />

          {isError && (
            <p style={{ color: "#c72418", margin: 0 }}>
              *Câmpuri necompletate sau tipul există deja !
            </p>
          )}
          <Buttons>
            <Button
              id="save-supplier"
              onClick={handleSave}
              text="SAVE"
              icon={<TfiSave />}
              backgroundColor={"var(--secondary-green)"}
              color="white"
            />
          </Buttons>
        </SettingWrapper>
      </Container>
    </Wrapper>
  );
};

export default AddCategoryComponent;
